import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Parse a "YYYY-MM-DD" date-only string as a LOCAL-time Date.
 *
 * `new Date("2026-06-01")` is spec-defined to parse as UTC midnight, which
 * displays as the *previous* calendar day for any user west of UTC (US
 * timezones). Use this helper anywhere we display a date stored as a
 * YYYY-MM-DD string (EOD activity logs, deals, alerts).
 *
 * Falls back to the native Date constructor for non-date-only strings
 * (e.g. full ISO timestamps) so timestamp formatting is unaffected.
 */
export function parseLocalDate(value) {
  if (value instanceof Date) return value;
  if (typeof value !== "string") return new Date(value);
  // Match strictly YYYY-MM-DD (no time component) — those are the bug-prone strings.
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!m) return new Date(value);
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
}
